<script>
	import { Card, Lives } from "./ui";

	export let player = {};
	export let index = 0;

	export let positions = [];

	$: column = positions[index].column;
	$: row = positions[index].row;
	$: cssVarStyles = `
		grid-column-start: ${column};
		grid-row-start: ${row};

		opacity: ${player.isOut ? .5 : 1}
	`;
</script>

<div class="player" style={cssVarStyles}>
	<div class="lives">
		<Lives lives={player.lives} isOut={player.isOut} size={30} />
	</div>
	<div class="data">
		<div>
			<div>
				{player.name}
			</div>
		</div>
		{#if player.revealed}
			<div class="cards">
				{#each player.cards as card}
					<Card {card} small />
				{/each}
			</div>
		{/if}
	</div>
</div>

<style>
	.player {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;

		background-color: rgba(255, 255, 255, .5);
		border-radius: 10px;

		padding-left: 20px;
		padding-right: 20px;
		margin-left: 5px;
		margin-right: 5px;
		height: 25vh;
	}

	.data {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.lives {
		display: flex;
		flex-direction: row;
	}

	.cards {
		display: flex;
		flex-direction: row;
	}
</style>